import React, { useState } from 'react';
import { BottomNavigation as KBottomNav, BottomNavigationTab as KBottomNavItem, Icon as KIcon, } from '@ui-kitten/components';
const Kitten = (props) => {
    const [tabIndex, setTabIndex] = useState(0);
    return (<KBottomNav selectedIndex={tabIndex} onSelect={setTabIndex} {...props}/>);
};
const KittenItem = (props) => {
    const { label, icon } = props;
    return (<KBottomNavItem {...props} title={label} icon={s => <KIcon {...s} name={icon}/>}/>);
};
export default {
    Kitten,
    NavItem: {
        Kitten: KittenItem,
    },
};
//# sourceMappingURL=BottomNav.js.map